// extracted by mini-css-extract-plugin
export default {"modal":"modal-567a","footer":"footer-f3f3"};